import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import en from 'element-plus/es/locale/lang/en';

export const elLocaleMap = {
    'zh-CN': zhCn,
    en: en,
};

export enum LocaleTypeEnum {
    English = 'en',
    Chinese = 'zh-CN',
}

export type LocaleType = 'zh-CN' | 'en'; //语言类型

export interface LocaleOptionType {
    // 语言配置选项
    value: LocaleType;
    label?: string;
}

const useLocaleStore = defineStore('locales', () => {
    const currentLocale = ref<LocaleTypeEnum>(LocaleTypeEnum.Chinese);
    const localeOption = ref<LocaleOptionType[]>([
        {
            value: 'zh-CN',
            label: '中',
        },
        {
            value: 'en',
            label: 'En',
        },
    ]);

    const isChinese = computed(() => currentLocale.value === LocaleTypeEnum.Chinese);
    const getCurrentLocale = computed(() => currentLocale.value);
    const getLocaleOption = computed(() => localeOption.value);

    function setCurrentLocale(localeType: LocaleTypeEnum) {
        currentLocale.value = localeType;
    }

    return {
        currentLocale,
        localeOption,
        isChinese,
        getCurrentLocale,
        getLocaleOption,
        setCurrentLocale,
    };
});

export default useLocaleStore;
